module.exports = __webpack_public_path__ + "media/images/icons/outlined/car-a048ce4353e022e0d504da55d92aaff9.svg";